import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Select, Store } from '@ngxs/store';
import { NGXLogger } from 'ngx-logger';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { Employee } from 'src/app/models/Employee';

import { EmployeesAddModalComponent } from '../employees-add-modal/employees-add-modal.component';
import { FetchEmployees } from '../employees.actions';
import { EmployeeState } from '../employees.state';

@Component({
    selector: 'app-employees-overview',
    templateUrl: './employees-overview.component.html',
    styleUrls: ['./employees-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class EmployeesOverviewComponent implements OnInit, OnDestroy {
    private subscriptions = new Subscription();

    @Select(EmployeeState.Employees) employees$: Observable<Employee[]>;
    activeEmployeesCount$: Observable<number>;
    activeEmployeesBreakdown$: Observable<{ active: number; payroll: number; freelance: number }>;

    constructor(private modalService: NgbModal, private store: Store, private logger: NGXLogger) {}

    ngOnInit(): void {
        this.logger.debug('Fetching Employees');
        this.activeEmployeesCount$ = this.employees$.pipe(map((employees) => employees?.filter((employee) => !employee.archived).length || 0));
        this.activeEmployeesBreakdown$ = this.employees$.pipe(
            map((employees) => {
                const activeEmployees = (employees || []).filter((employee) => !employee.archived);
                const payroll = activeEmployees.filter((employee) => (employee.type || 'PAYROLL') === 'PAYROLL').length;
                const freelance = activeEmployees.filter((employee) => employee.type === 'FREELANCE').length;
                return {
                    active: activeEmployees.length,
                    payroll,
                    freelance,
                };
            }),
        );
        this.subscriptions.add(this.store.dispatch(new FetchEmployees()).subscribe());
    }

    openAddEmployeesModal() {
        this.logger.debug('Opening employeesAddModal');
        const modalRef = this.modalService.open(EmployeesAddModalComponent, {
            windowClass: 'modal-pane',
            animation: false,
        });
        modalRef.componentInstance.inOverview = true;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
